'use client'
import * as React from 'react'
import { tw } from 'utils/classnames'

export type SupportedBackgrounds = 'service-white' | 'gray-900'

export function InfiniteSlider({
  items,
  direction = 'left',
  backgroundColor = 'service-white',
}: {
  items: React.ReactNode[]
  duration?: number
  direction?: 'left' | 'right' | 'up' | 'down'
  backgroundColor?: SupportedBackgrounds
}) {
  if (!items || !Array.isArray(items)) {
    return null
  }

  const animatesHorizontal = direction === 'left' || direction === 'right'
  const animatesVertical = direction === 'up' || direction === 'down'

  const gradientBackgrounds: Record<SupportedBackgrounds, string> = {
    'service-white': 'before:from-service-white after:from-service-white',
    'gray-900': 'before:from-gray-900 after:from-gray-900',
  }

  return (
    <div
      className={tw(
        animatesHorizontal &&
          `before:absolute before:left-0 before:top-0 before:z-[2] before:h-full before:w-[200px] before:bg-gradient-to-r before:content-['']
          after:absolute after:right-0 after:top-0 after:z-[2] after:h-full after:w-[200px] after:bg-gradient-to-l after:content-['']
          ${gradientBackgrounds[backgroundColor]}`,
        animatesVertical && 'flex-col',
        'relative flex gap-5 overflow-hidden whitespace-nowrap',
      )}
    >
      <div
        className={tw(
          direction === 'left' && 'animate-slideLeft',
          direction === 'right' && 'animate-slideRight',
          direction === 'up' && 'animate-slideUp',
          direction === 'down' && 'animate-slideDown',
        )}
      >
        <div className={tw(animatesVertical && 'flex-col', 'flex gap-5')}>
          {[...items].map((child, index) => (
            <div key={`slider_1_child_${index}`}>{child}</div>
          ))}
        </div>
      </div>
      <div
        className={tw(
          direction === 'left' && 'animate-slideLeft',
          direction === 'right' && 'animate-slideRight',
          direction === 'up' && 'animate-slideUp',
          direction === 'down' && 'animate-slideDown',
        )}
      >
        <div className={tw(animatesVertical && 'flex-col', 'flex gap-5')}>
          {[...items].map((child, index) => (
            <div key={`slider_2_child_${index}`}>{child}</div>
          ))}
        </div>
      </div>
    </div>
  )
}
